import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { AppState, Dispatch } from 'store/types'
import { Table } from 'components/UI/CompactTable'
import { Search } from 'components/UI/Search'
import {
  deleteUser,
  fetchPatients,
  resetUserPassword
} from 'ducks/patients/operations'
import { DotsButton, DropdownList } from 'components/common'
import DropMenu from 'components/UI/DropMenu'
import { MenuOption } from 'components/common/DropdownList'
import { ContentBlock } from 'components/common'
import Pagination from '../../components/UI/Pagination'

const headers = {
  columns: [{ name: 'Name' }, { name: 'Email' }, { name: 'Phone' }] // { name: 'Phone' } { name: 'Member ID' }
}

class PatientsListPage extends Component<Props, PatientsListState> {
  constructor(props: Props) {
    super(props)

    this.state = {
      filtered: [],
      actualPage: 0,
      actualPages: [],
      pageNumbers: [],
      chunks: [],
      searchText: ''
    }
  }

  componentDidMount(): void {
    this.props.fetchPatients(9, 0)
    this.setState({ filtered: this.props.patients })
  }
  componentDidUpdate(prevProps: any) {
    const { patients = [], loadedPageNumber = 0 } = this.props
    if (
      prevProps.loadedPageNumber !== loadedPageNumber ||
      prevProps.patients.length !== patients.length
    ) {
      this.setState({ filtered: patients })
    }
  }

  noItems = () => (
    <TextBlock>
      <p>You don’t have any patients.</p>
    </TextBlock>
  )
  onSearch = (text: string) => {
    const { actualPage } = this.state
    // const value = text.toLowerCase()
    // const filter = patients.filter(
    //   (item: { firstName: string; lastName: string }) => {
    //     return `${item.firstName + ' ' + item.lastName}`
    //       .toLowerCase()
    //       .includes(value)
    //   }
    // )
    if (!text) {
      // this.setState({
      //   filtered: this.props.patients
      // })
      this.props.fetchPatients(9, 0)
      return
    }
    // this.setState({
    //   filtered: filter
    // })
    // this.props.fetchPatients(NaN, NaN, text)
    this.props.fetchPatients(9, actualPage, text)
  }
  onPageChanged = (actualPage: number) => {
    const { searchText } = this.state

    if (searchText) {
      this.props.fetchPatients(9, actualPage, searchText)
      return
    }
    this.setState({ actualPage })
    this.props.fetchPatients(9, actualPage)
  }

  // chunk(array: any[], size: number) {
  //   const chunkedArr = []
  //   // tslint:disable-next-line:prefer-for-of
  //   for (let i = 0; i < array.length; i++) {
  //     const last = chunkedArr[chunkedArr.length - 1]
  //     if (!last || last.length === size) {
  //       chunkedArr.push([array[i]])
  //     } else {
  //       last.push(array[i])
  //     }
  //   }
  //   return chunkedArr
  // }
  // getPaginationData = (data: any[]) => {
  //   const chunks = this.chunk(data, 9)
  //   const pageNumbers = Object.keys(chunks)
  //   this.setState({ pageNumbers, chunks, filtered: data.slice(0, 9) })
  // }
  onHandleClear = () => {
    this.props.fetchPatients(9, 0)
    this.setState({
      filtered: this.props.patients,
      searchText: ''
    })
  }

  render() {
    const { patients, patientsTotalPages } = this.props
    const pages: Array<number | any[]> = []
    // @ts-ignore
    for (let a = patientsTotalPages - 1; a > -1; a--) {
      pages.unshift(a)
    }
    const menuOptions: MenuOption[] = [
      {
        text: 'Reset Password',
        onClick: (id: string) => {
          if (id) {
            this.props.resetUserPassword(id)
          }
        }
      },
      {
        text: 'Delete',
        variant: 'text-danger',
        onClick: (id: string) => {
          if (id) {
            this.props.deleteUser(id)
          }
        }
      }
    ]
    const actionBlock = (id: string) => {
      return (
        <DropMenu target={<DotsButton />}>
          <DropdownList menuOptions={menuOptions} id={id} />
        </DropMenu>
      )
    }
    const getActionsBlock = (id: any) => {
      return actionBlock(id)
    }

    const getTableBody = (patientsList: any[]) => {
      const { filtered = [] } = this.state
      const mainList = filtered
      return mainList.map((row: any) => ({
        id: row.id,
        columns: [
          `${row.firstName + ' ' + row.lastName}`,
          row.email ? row.email : '-',
          row.mobileNumber ? row.mobileNumber : '-'
          // row.memberId ? row.memberId : '-'
        ]
      }))
    }

    return (
      <WrapBlock>
        <HeadTitle>
          <Title>Users</Title>
          <RightHeadTitle>
            <Search
              onSearch={this.onSearch}
              onHandleClear={this.onHandleClear}
            />
          </RightHeadTitle>
        </HeadTitle>
        {patients.length === 0 || this.state.filtered.length === 0 ? (
          <ContentBlock isCentered={true}>{this.noItems()}</ContentBlock>
        ) : (
          <>
            <Table
              header={headers}
              body={getTableBody(patients)}
              actionBlock={getActionsBlock}
              goTo={(id, isNew) => `/patientDetail/${id}`}
            />
            {patientsTotalPages !== 0 && (
              <Pagination onPageChanged={this.onPageChanged} allPages={pages} />
            )}
          </>
        )}
      </WrapBlock>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps {}
interface PatientsList {
  carrierName: string
  lastName: string
  email: string
  number: string
}
type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
interface PatientsListState {
  filtered: PatientsList[]
  actualPage: number
  actualPages: number[]
  chunks: any
  pageNumbers: any
  searchText: string
}
type Props = StateProps & DispatchProps & ReceivedProps

const mapStateToProps = (state: AppState) => ({
  isAccountCreated: state.auth.registrationData,
  patients: state.patients.data.content,
  patientsTotalPages: state.patients.data.totalPages
    ? state.patients.data.totalPages
    : 0,
  loadedPageNumber: state.patients.data.number ? state.patients.data.number : 0
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      fetchPatients,
      deleteUser,
      resetUserPassword
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientsListPage)

const WrapBlock = styled.div``

const Title = styled.h1`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0;
`

const HeadTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.5rem;
`

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;

  p {
    color: #152735;
    margin-bottom: 1.5rem;
  }
`
const RightHeadTitle = styled.div`
  display: flex;
  flex-direction: row;

  > a,
  > button {
    margin-left: 30px;
    min-width: auto;
  }
`
